const MY_ACCOUNT_PAGE = {
  formError: {
    emailRequired: 'Campo obrigatio',
    passwordRequired: 'Campo obrigatorio',
    notMatch: 'As senhas devem coincidir',
  },
  financialAccess: 'Acesso Financeiro',
  operationalAccess: 'Acesso Operacional',
  centerText: 'Minha conta',
  closed: 'Fechado',
  close: 'Fechar',
  save: 'Salvar',
  cancel: 'Cancelar',
  hi: 'Olá',
  title: 'Informações da conta',
  subtitle: 'Aqui você pode ver os dados cadastrais do seu ponto de venda.',
  edit: 'Editar Dados',
  welcomeMessage: {
    editAddressText:
      'Novidade: agora é possível editar seu endereço e outros dados no Seu Zé de forma fácil e rápida, basta clicar em ”EDITAR DADOS” na área de "Informações Gerais” logo abaixo.',
  },
  pocInfo: {
    title: 'Informações gerais',
    tip: {
      editAddress:
        'Para alterar o endereço da sua loja, é necessário entrar em contato via chat.',
      editInfo: {
        edit: 'Para alterar outros números de telefone, razão social e/ou o CNPJ entre em contato pelo',
        chat: 'chat',
      },
    },
    deliveryRate: 'Taxa de entrega: R$',
    nameOfPoc: 'Nome Fantasia',
    address: 'Endereço',
    document: 'CNPJ',
    id: 'ID',
  },
  contacts: {
    title: 'Contatos',
    establishmentPhones: 'Outros Telefones',
    responsiblePhones: 'Telefone do(a) Responsável',
  },
  accessData: {
    title: 'Acessos',
    tip: {
      edit: 'Para editar os acessos entre em contato pelo',
      chat: 'chat',
    },
  },
  bankInfo: {
    title: 'Dados bancários',
  },
  daysHours: {
    title: 'Dias e Horários',
  },
  ratings: {
    title: 'Ratings',
  },
  deliveryArea: {
    title: 'Área de Entrega',
    titleHexa: 'Área de entrega',
    aboutTab: 'Essa área inclui os pedidos:',
    scheduledOrders: 'Programado',
    receiveOrders: 'Comum',
    conventionalDeliveries: 'Comum',
    turboDelivery: 'Turbo',
  },
  legalTerms: {
    title: 'Termos legais',
    remunerationPlan: 'Plano de Remuneração',
    remunerationPlanText:
      ' Indicadores de desempenho mínimo, valores para restituição e taxas para processamento das vendas no cartão de crédito online.',
    generalPartnershipTerms: 'Termos gerais de parceria',
    generalPartnershipTermsText:
      'É o contrato de parceria determinando os direitos e responsabilidades entre o Zé Delivery e o seu negócio.',
    close: 'Fechar',
  },
  deliverymanApproval: {
    titleDefault: 'Aprovação de entregadores',
    title: 'Pessoas entregadoras',
    titleHexa: 'Aprovar',
    descriptionDefault:
      'Torne seus entregadores ativos e deixe-os prontos para começar',
    description:
      'Aprove, exclua e tenha a visibilidade do status das pessoas entregadoras da sua loja.',
    actionButtonDefault: 'Aprovar entregadores',
    actionButton: 'Gerenciar Frota',
  },
  visualize: 'Visualizar',
  download: 'Baixar',
  defaultRequestErrorMessage: 'Houve um erro, tente novamente mais tarde.',
  integration: {
    title: 'Integrações',
    subtitle:
      'Plataformas com as quais o Zé Delivery possibilita integração. Essas soluções se conectam ao Zé e trabalham juntas para trazer mais facilidade para sua rotina',
    error: 'Não foi possível atualizar sua integração',
    getIntegratorsError: 'Não foi possível carregar os integradores',
    activateModal: {
      title: 'Confirmar integração',
      description: `O PDV autoriza expressamente que o $integratorDisplayName acesse o ambiente API Zé (disponível por meio do link https://seller-public-api.ze.delivery/docs) e utilize os dados fornecidos pelo PDV para a prestação dos serviços em conexão com a API Zé. O fornecimento dos dados é de exclusiva responsabilidade do PDV. A presente autorização vigerá por prazo indeterminado. No evento de sua revogação, o PDV se responsabilizará por notificar o Zé Delivery, para que este possa revogar o acesso do $integratorDisplayName a API ZÉ.`,
      status: 'Ativado',
    },
    deactivateModal: {
      title: 'Confirmar desligamento',
      subtitle: 'Você deseja desabilitar a integração com',
      status: 'Desativado',
    },
    integrationTypes: {
      financial: 'Frente de caixa',
      logistic: 'Operador Logístico',
      erp: 'ERP',
    },
    backButton: 'voltar',
    confirmButton: 'confirmar',
    cardImageDescription: 'Logo do parceiro',
  },
}

export default MY_ACCOUNT_PAGE
